import { useApiStore } from "@/stores/api/index.ts";

const fetchAnalytics = async (module, { startDate, endDate }) => {
  const api = useApiStore();
  const { getters, commit, dispatch } = module;
  try {
    const { data } = await dispatch("httpRequest", {
      func: api.fetchAnalytics(startDate, endDate),
      config: {
        isCms: false,
        isAuth: true,
      },
    });
    const { analytics } = data;
    commit("storeAnalytics", analytics);
  } catch (err) {
    commit("storeAnalytics", null);
    console.error("Error fetching analytics", err);
  }
  return getters.analytics();
};

export { fetchAnalytics };
